<template>
    <!-- 程序文件模板库 -->
    <div class="mod-config">
        <el-card :style="{ height: screenHeight - 71 + 'px' }" class="file-template-card">
            <div class="card-header">
                <div class="title">程序文件模板库</div>
                <div class="line"></div>
            </div>
            <!-- 添加滚动容器 -->
            <div class="scroll-container">
                <div class="template-container">
                    <div v-for="(item, index) in templateList" :key="item.recno" class="template-item" @click="downloadTemplate(item.recno, item.templateName)">
                        <div class="template-icon">
                            <img :src="require('@/assets/svg-icons/word-file.svg')" alt="Word文件" class="word-icon" />
                        </div>
                        <span class="template-name">
                            {{ item.templateName }}
                        </span>
                    </div>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import $common from "@/utils/common.js"
export default {
    data() {
        return {
            inline: false,
            templateList: [],
            screenHeight: 0
        };
    },
    computed: {},
    components: {},
    mounted() {
        this.screenHeight = window.innerHeight
        this.getFileTemplateList();
    },
    methods: {
        getFileTemplateList() {
            this.$http({
                url: this.$store.state.httpUrl + "/business/filetemplate/list/" + $common.getItem("workNo"),
                method: 'get',
                params: {}
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.templateList = data.body;
                }
            })
        },
        downloadTemplate(recno, filename) {
            filename = filename + '模版文件'

            this.$http({
                url: this.$store.state.httpUrl + "/business/filetemplate/downloadTemplate",
                method: 'get',
                params: this.$http.adornParams({
                    workNo: $common.getItem("workNo"),
                    recno: recno
                })
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    filename = this.getSuffix(data.body, filename)
                    this.getBlob(data.body, (blob) => {
                        this.saveAs(blob, filename)
                    })
                }
            })
        },
        getSuffix(url, filename) {
            let lastIndex = url.lastIndexOf(".");
            return filename + url.substr(lastIndex)
        },
        getBlob(url, cb) {
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url, true)
            xhr.responseType = 'blob'
            xhr.onload = function () {
                if (xhr.status === 200) {
                    cb(xhr.response)
                }
            }
            xhr.send()
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename)
            }
            else {
                var link = document.createElement('a')
                var body = document.querySelector('body')

                link.href = window.URL.createObjectURL(blob)
                link.download = filename

                link.style.display = 'none'
                body.appendChild(link)

                link.click()
                body.removeChild(link)
                window.URL.revokeObjectURL(link.href)
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.mod-config {
    height: 100%;
}

.file-template-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    
    ::v-deep .el-card__body {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 0;
    }
}

.card-header {
    padding: 20px 30px 0;
    
    .title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
    }
    
    .line {
        height: 1px;
        background: #e4e7ed;
        margin-top: 10px;
    }
}

/* 新增滚动容器样式 */
.scroll-container {
    flex: 1;
    overflow-y: auto;
    padding: 10px 30px;
    min-height: 0; /* 重要：确保flex子元素能正确收缩 */
}

/* 自定义滚动条样式 */
.scroll-container::-webkit-scrollbar {
    width: 8px;
}

.scroll-container::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 4px;
}

.scroll-container::-webkit-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 4px;
}

.scroll-container::-webkit-scrollbar-thumb:hover {
    background: #909399;
}

/* Firefox */
.scroll-container {
    scrollbar-width: thin;
    scrollbar-color: #c0c4cc #f5f5f5;
}

.template-container {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
}

.template-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    cursor: pointer;
    border: 1px solid #e4e7ed;
    min-height: 120px;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transform: translateY(-2px);
        border-color: #409EFF;
    }
}

.template-icon {
    margin-bottom: 12px;
    
    .word-icon {
        width: 60px;
        height: 60px;
        color: #2b5797; /* Word文档的蓝色 */
    }
}

.template-name {
    cursor: pointer;
    color: #333;
    font-size: 14px;
    text-align: center;
    line-height: 1.4;
    word-break: break-all;
    max-width: 100%;
    color: #409EFF;
    padding: 2px 4px;
    border-radius: 2px;

    &:hover {
        color: #fff;
        background-color: #409EFF;
    }
}

.download-link {
    color: #409EFF;
    
    &:hover {
        color: #66b1ff;
        text-decoration: underline;
    }
}
</style>